export enum FeatureFlag {
  ACTIVITY_FEED_FF = 'ACTIVITY_FEED_FF',
  AD_BUILDER_FF = 'AD_BUILDER_FF',
  API_KEYS_FF = 'API_KEYS_FF',
  CART_ANALYSIS_FF = 'CART_ANALYSIS_FF',
  CC_CREATIVE_ANALYSIS_FF = 'CC_CREATIVE_ANALYSIS_FF',
  CC_CREATIVE_HUB_FF = 'CC_CREATIVE_HUB_FF',
  COGS_PAGE_FF = 'COGS_PAGE_FF',
  COST_SETTINGS_FF = 'COST_SETTINGS_FF',
  CUSTOM_METRICS_FF = 'CUSTOM_METRICS_FF',
  CUSTOM_EXPENSES_FF = 'CUSTOM_EXPENSES_FF',
  CUSTOMERS_PAGE_FF = 'CUSTOMERS_PAGE_FF',
  EMAIL_SLACK_REPORT_FF = 'EMAIL_SLACK_REPORT_FF',
  EXPENSES_ACCESS_FF = 'EXPENSES_ACCESS_FF',
  EXPORT_TO_SHEETS_FF = 'EXPORT_TO_SHEETS_FF',
  EXTERNAL_API_FF = 'EXTERNAL_API_FF',
  FINHUB_FF = 'FINHUB_FF',
  FORECASTING_FF = 'FORECASTING_FF',
  HUBSPOT_MEETING_FF = 'HUBSPOT_MEETING_FF',
  INSIGHT_GENERAL_FF = 'INSIGHT_GENERAL_FF',
  INVITE_USER_LIMIT_FF = 'INVITE_USER_LIMIT_FF',
  LIGHTHOUSE_FF = 'LIGHTHOUSE_FF',
  LIMIT_CUSTOM_METRICS_FF = 'LIMIT_CUSTOM_METRICS_FF',
  LIMIT_INTEGRATIONS_FF = 'LIMIT_INTEGRATIONS_FF',
  LIMIT_LOOKBACK_FF = 'LIMIT_LOOKBACK_FF',
  LIMIT_METRICS_FF = 'LIMIT_METRICS_FF',
  LIMIT_NOTIFICATIONS_FF = 'LIMIT_NOTIFICATIONS_FF',
  LIMIT_PIXEL_COLUMNS_FF = 'LIMIT_PIXEL_COLUMNS_FF',
  LIMIT_ROUTES_FF = 'LIMIT_ROUTES_FF',
  LIMIT_SUMMARY_SECTIONS_FF = 'LIMIT_SUMMARY_SECTIONS_FF',
  ORDERS_PAGE_FF = 'ORDERS_PAGE_FF',
  PAYMENT_GATEWAY_COSTS_PAGE_FF = 'PAYMENT_GATEWAY_COSTS_PAGE_FF',
  PIXEL_AFFLUENCER_HUB_FF = 'PIXEL_AFFLUENCER_HUB_FF',
  PIXEL_ALL_FF = 'PIXEL_ALL_FF',
  PIXEL_CHANNEL_OVERLAP_FF = 'PIXEL_CHANNEL_OVERLAP_FF',
  PIXEL_EMAIL_FF = 'PIXEL_EMAIL_FF',
  PIXEL_LIVE_ORDERS_FF = 'PIXEL_LIVE_ORDERS_FF',
  PIXEL_ORGANIC_FF = 'PIXEL_ORGANIC_FF',
  PIXEL_PURCHASE_POPUP_FF = 'PIXEL_PURCHASE_POPUP_FF',
  POST_PURCHASE_SURVEY_FF = 'POST_PURCHASE_SURVEY_FF',
  PRODUCT_ANALYTICS_FF = 'PRODUCT_ANALYTICS_FF',
  SCDP_PAGE_FF = 'SCDP_PAGE_FF',
  SEGMENTATION_FF = 'SEGMENTATION_FF',
  SHIPPING_PAGE_FF = 'SHIPPING_PAGE_FF',
  SPENDS_PAGE_FF = 'SPENDS_PAGE_FF',
  SUMMARY_PAGE_FF = 'SUMMARY_PAGE_FF',
  STORE_DATA_FF = 'STORE_DATA_FF',
  TW_3_0_FF = 'TW_3_0_FF',
  USE_NEW_DESIGN_FF = 'USE_NEW_DESIGN_FF',
  WILLY_CHAT_FF = 'WILLY_CHAT_FF',

  // These are TBD
  // RULES_ENGINE_FF = "RULES_ENGINE_FF",
  // PROFESSIONAL_SERVICES_FF = "PROFESSIONAL_SERVICES_FF",
  // CAPI_FF = "CAPI_FF",
  // API_FF = "API_FF",
  // CC_GENERAL_FF  = "CC_GENERAL_FF",
  // LIVE_CHAT_FF = "LIVE_CHAT_FF",
  // PIXEL_DATA_EXPORT_FF = "PIXEL_DATA_EXPORT_FF",
}
